import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { enums } from '../../config';
import AuthLayout, { FormAlert, responseCode, usePageTitle } from '../Login/AuthLayout';

const Page = (props) => {
    const code = props.match.params.code;
    const [t] = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    usePageTitle(t('auth.recoveryTitle'));

    const submit = (values) => {
        if (loading) return;
        setLoading(true);
        setError('');
        axios.post(`/users/recoverypassword`, { password: values.password, resetPasswordKey: code })
            .then(res => {
                localStorage.setItem('auth-token', res.data);
                window.location = '/admin';
            })
            .catch(err => {
                const errorCode = responseCode(err);
                // c4: no account holds this key any more (used, or replaced by a newer one)
                if (errorCode === enums.errorCodes.c4) setError(t('auth.recoveryInvalid'));
                else if (errorCode === enums.errorCodes.c7) setError(t('inputErrors.passwordLeast4'));
                else setError(t('auth.genericError'));
            })
            .finally(() => setLoading(false));
    };

    return (
        <AuthLayout
            title={t('auth.recoveryTitle')}
            subtitle={t('auth.recoverySub')}
            footer={<Link className="auth-link auth-back" to="/login"><ArrowLeftOutlined /> {t('auth.backToLogin')}</Link>}
        >
            <Form layout="vertical" requiredMark={false} size="large" onFinish={submit} className="normal_login_form">
                <Form.Item name="password" label={t('auth.newPassword')} extra={t('auth.passwordHint')}
                    rules={[
                        { required: true, message: t('inputErrors.requiredThisField') },
                        { min: 4, message: t('inputErrors.passwordLeast4') }
                    ]}>
                    <Input.Password autoFocus autoComplete="new-password" />
                </Form.Item>
                <Form.Item
                    name="confirm"
                    label={t('passwordRepeat')}
                    dependencies={['password']}
                    rules={[
                        { required: true, message: t('inputErrors.requiredThisField') },
                        ({ getFieldValue }) => ({
                            validator(rule, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(t('inputErrors.passwordsNotMatch'));
                            },
                        }),
                    ]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
                <FormAlert message={error} />
                <Button block loading={loading} type="primary" htmlType="submit" className="login-form-button">
                    {t('auth.savePassword')}
                </Button>
            </Form>
        </AuthLayout>
    );
};

export default Page;
